import React from "react";
import PropTypes from "prop-types";
import { Controller } from "react-hook-form";
import { InputLabel, FormControl, Select } from "@material-ui/core";

const SelectInput = (props) => {
    const { control, name, label, children, rules, disabled, multiple } = props;

    const [values, setValues] = React.useState([]);
    const handleChange = (event) => {
        setValues(event.target.value);
    };

    return (
        <Controller
            name={name}
            control={control}
            rules={rules}
            defaultValue={multiple ? [] : "specijalista"}
            render={({ field }) => (
                <FormControl fullWidth margin="normal">
                    <InputLabel>{label}</InputLabel>
                    <Select disabled={disabled} multiple={multiple} value={values} onChange={handleChange} fullWidth {...field}>
                        {children}
                    </Select>
                </FormControl>
            )}
        />
    );
};

SelectInput.propTypes = {
    control: PropTypes.object,
    rules: PropTypes.object,
    label: PropTypes.string,
    name: PropTypes.string,
    children: PropTypes.array,
    className: PropTypes.string,
    placeholder: PropTypes.string,
    disabled: PropTypes.bool,
    multiple: PropTypes.bool
};

export default SelectInput;
